/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import Agent from "sharedb/lib/agent";
import { Connection } from "sharedb/lib/client";
import ConnectionInternal from "sharedb/lib/client/connection";

/**
 * There is bug in our interaction with ShareDB presence that causes a presence request loop,
 * and this is a temporary measure to prevent the issue from occurring, at the cost of some
 * functionality.
 * The fix is turning requesting and reacting to "pr" (presenceRequest) actions into a no-op,
 * which means that arriving at a new Page will no longer request (and show) presence data
 * of existing users. Only subsequent new user interactions will show up.
 *
 * The _handlePresenceRequest prevents the client from handling presence requests, and
 * the _requestPresence prevents the server from sending presence requests to clients when
 * a new client subscribes to presences.
 */
ConnectionInternal.prototype._handlePresenceRequest = function _handlePresenceRequest() {
  // noop
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(Agent as any).prototype._requestPresence = function _requestPresence(_, callback?: () => void) {
  // noop
  if (callback) {
    callback();
  }
};

/**
 * Patches ShareDB Connection to ignore non-ShareDB protocol messages:
 * - pong: Response to our ping messages
 */
export function patchShareDBConnection() {
  const originalFunc = Connection.prototype.handleMessage;

  Connection.prototype.handleMessage = function handleMessage(message) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const boundOriginal = originalFunc.bind(this);

    // Silently ignore non-ShareDB messages
    if (message.a === "pong") {
      return;
    }

    // Forward everything else to ShareDB
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    boundOriginal(message);
  };
}
